"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when unable to extend object via extendObjectFromKey
 * @param {string} explanation
 */
class ExtendObjectError extends ExtendableError_1.default {
    constructor(explanation, key) {
        super(`Could not extend object at ${key}, because: ${explanation}`);
        this.explanation = explanation;
        this.key = key;
    }
}
exports.default = ExtendObjectError;
